import _ from 'lodash'
import {createCachedSelector} from 're-reselect'
import {createSelector} from 'reselect'
import {createSmartCachedSelector} from '../selectors'
import {currentEnvIdSelector, orgEnvsSelector} from '../use_shared'

export const settingsSelector = state => state.settings.environments

export const getEnvSettingGroup = createCachedSelector(
	settingsSelector,
	(state, kind) => kind,
	(state, kind, env_id) => env_id || currentEnvIdSelector(state),
	(settings, kind, envId) => (settings[envId] ? settings[envId][kind] : null),
)((settings, kind, envId) => `${kind}-${envId}`)

export const getEnvSetting = createCachedSelector(
	settingsSelector,
	(state, kind) => kind,
	(state, kind, key) => key,
	(state, kind, key, env_id) => env_id || currentEnvIdSelector(state),
	(settings, kind, key, envId) => {
		return settings[envId] && settings[envId][kind] ? settings[envId][kind][key] : null
	},
)((settings, kind, key, envId) => `${kind}-${key}-${envId}`)

export const orgEnvsSettingsSelector = createSelector(orgEnvsSelector, settingsSelector, (orgEnvs, settings) => {
	const ids = orgEnvs.map(e => e.id)
	const envSettings = _.pick(settings, ids)
	return envSettings
})

export const orgEnvsSettingGroupSelector = createSmartCachedSelector(
	orgEnvsSettingsSelector,
	(state, kind) => kind,
	(settings, kind) => _.mapValues(settings, kind),
)

export const orgEnvSettingSelector = createSmartCachedSelector(
	orgEnvsSettingGroupSelector,
	(state, kind) => kind,
	(state, kind, key) => key,
	(settings, kind, key) => _.map(settings, key),
)

export const orgEnvSettingKeyValueSelector = createSmartCachedSelector(
	orgEnvsSettingGroupSelector,
	(state, group) => group,
	(state, group, key) => key,
	(settings, group, key) => {
		const obj = {}
		Object.keys(settings).forEach(envId => (obj[envId] = settings[envId] && settings[envId][key]))
		return obj
	},
)
